// extracted by mini-css-extract-plugin
module.exports = {"pintxo-avatar":"Avatar_pintxo-avatar__j2S1d","pintxo-avatar__shape":"Avatar_pintxo-avatar__shape__upB9F","pintxo-avatar__shape__text":"Avatar_pintxo-avatar__shape__text__7DB6Y"};